import types from './actionTypes';
import cloneDeep from 'lodash.clonedeep';

const initialState = null;

/** Add new section */
const addNewSection = (item, parentID, index, state) => {
    let schema = state.schema;
    let elementindex = index === undefined ? schema.length : index;
    schema.splice(elementindex, 0, item);
    if (parentID == null) {
        return {
            ...state,
            schema: [...schema]
        }
    }
}

const updateSectionSchema = ({ section, parentID }, state) => {
    return {
        ...state,
        schema: [...state.schema.map((val) => val.id === section.id ? section : val)]
    }
}

// For adding the ui to childrens of a section
const addUISchema = ({ section }, state) => {
    return {
        ...state,
        schema: [...state.schema.map((val) => val.id === section.id ? section : val)]
    }
}

// For updating a ui in the childrens of a section
const updateUISchema = ({ section }, state) => {
    return {
        ...state,
        schema: [...state.schema.map((val) => val.id === section.id ? section : val)]
    }
}

const deleteSectionSchema = ({ section, parentId }, state) => {
    return {
        ...state,
        schema: state.schema.filter(item => item.id !== section)
    }
}

const resetView = (state) => {
    return cloneDeep(initialState);
}

// For adding the field to childrens of a ui
const addFieldSchema = (payload, state) => {
    return {
        ...state,
        view_schema: [...state.schema.map((val) => val.id === payload._id ? payload : val)]
    }
}

// For updating the field in childrens of a ui
const updateFieldSchema = (payload, state) => {
    return {
        ...state,
        view_schema: [...state.schema.map((val) => val.id === payload._id ? payload : val)]
    }
}

const addView = (payload, state) => {
    return [
        ...state,
        payload
    ]
}

const interruptView = (_, state) => {
    console.log(state,'this is state')
    return {
        ...state,
        interrupt: true
    }
}



const deleteView = (payload, state) => {
    return {};
}

const updateCompleteViews = (payload, state) => {
    return [
        ...state,
        ...payload.views
    ]
}

const updateFullViews = (payload, state) => {
    return payload;
}

// const setView = (payload, state) => {
//     return {
//         ...state,
//         ...payload
//     };
// }

const setView = (payload) => payload;


const editView = (payload, state) => {
    return {
        ...state,
        ...payload
    };

}


export default function appReducer(state = initialState, action) {


    switch (action.type) {


        case types.ADD_ITEM_TO_SCHEMA:
            return addNewSection(action.payload.item, action.payload.parentID, action.payload.index, state);

        case types.UPDATE_SECTION_SCHEMA:
            return updateSectionSchema(action.payload, state);

        case types.ADD_UI_SCHEMA:
            return addUISchema(action.payload, state);

        case types.UPDATE_UI_SCHEMA:
            return updateUISchema(action.payload, state);

        case types.DELETE_SECTION_SCHEMA:
            return deleteSectionSchema(action.payload, state);

        case types.ADD_FIELD_SCHEMA:
            return addFieldSchema(action.payload, state);

        case types.UPDATE_FIELD_SCHEMA:
            return updateFieldSchema(action.payload, state);

        case types.RESET_VIEW:
            return resetView(state);

        case types.ADD_VIEW:
            return addView(action.payload, state);

        case types.EDIT_VIEW:
            return editView(action.payload, state);

        case types.DELETE_VIEW:
            return deleteView(action.payload, state);

        case types.UPDATE_COMPLETE_VIEWS:
            return updateCompleteViews(action.payload, state);

        case types.UPDATE_FULL_VIEWS:
            return updateFullViews(action.payload, state);

        case types.SET_VIEW:
            return setView(action.payload, state);
        case types.SET_VIEW_INTERRUPT:
            return interruptView()
        default:
            return state;
    }
}
